import { net } from "../store.js";

/** Boss HP bar — only during the boss phase. */
export function BossBar() {
  const n = net.value;
  if (n === null || n.runPhase !== "boss" || n.bossMaxHp <= 0) return null;
  const frac = Math.max(0, Math.min(1, n.bossHp / n.bossMaxHp));
  return (
    <div class="absolute top-14 left-1/2 -translate-x-1/2 flex w-[420px] flex-col items-center gap-1">
      <div class="text-sm font-bold tracking-wide text-rose-300">FINAL BOSS</div>
      <div class="relative h-3.5 w-full overflow-hidden rounded-sm border border-rose-500/60 bg-[#1a0e14]">
        <div
          class="absolute inset-y-0 left-0 bg-rose-500 transition-[width] duration-150"
          style={{ width: `${frac * 100}%` }}
        />
      </div>
    </div>
  );
}
